<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-05-08 14:21:15
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-05-17 14:11:20
-->
<template>
  <div class="applicationLogin">
    <div class="header">
      <div class="c-1200">
        <div class="logo">
          <img src="../../assets/exam/login_logo.png" alt="" />
          <span>职业技能等级考试系统</span>
        </div>
        <div class="port">考生端</div>
      </div>
    </div>
    <div class="content">
      <div class="title">报名列表</div>
      <div class="list">
        <div class="list-item" v-for="item in list" :key="item.id">
          <div class="info">
            <div class="name">
              <span>{{ item.jobName }}</span>
              <span>{{ item.jobLevel }}</span>
            </div>
            <div class="date">报名时间：{{ item.registrationTime }}</div>
          </div>
          <div
            :class="[
              'status',
              { success: item.status == 2 },
              { danger: item.status == 3 },
            ]"
          ></div>
          <div class="btns">
            <el-button v-if="item.status == 3" class="btn" @click="toEdit(item)"
              >修改</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userQueryIdCard } from "@/api/application";
import to from "await-to";
export default {
  data() {
    return {
      idCard: this.$route.query.idCard,
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const [res, err] = await to(userQueryIdCard({ idCard: this.idCard }));
      if (err) return this.$message.warning(err.msg);
      console.log(`output->res`, res);
      this.list = res.data;
    },
    toEdit(item) {
      this.$router.push({
        path: `/application/info/${item.id}`,
        query: {
          idCard: this.$route.query.idCard,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.applicationLogin {
  background-color: #f5f7fa;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 70px;
    background: #ffffff;
    margin-bottom: 20px;
    .c-1200 {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo {
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
        span {
          display: block;
          height: 24px;
          line-height: 22px;
          position: relative;
          font-size: 18px;
          font-weight: 500;
          color: #3671bf;
          border-left: 1px solid #c1c8d1;
          padding-left: 12px;
        }
      }
      .port {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 90px);
    background-color: #fff;
    .title {
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      background: #ffffff;
      border-bottom: 1px solid #e8ebf2;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      line-height: 60px;
      padding-left: 30px;
    }
    .list {
      width: 100%;
      box-sizing: border-box;
      padding: 23px 30px 22px;
      .list-item {
        height: 90px;
        background: #fffcfc;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #fff1f1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 18px 38px 18px 28px;
        box-sizing: border-box;
        margin-bottom: 20px;
        .info {
          flex: 1;
          .name {
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            margin-bottom: 20px;
            span {
              margin-right: 30px;
            }
          }
          .date {
            font-size: 14px;
          }
        }
        .status {
          width: 87px;
          height: 67px;
          background-repeat: no-repeat;
          margin-right: 300px;
          &.success {
            background-image: url("../../assets/application/pass.png");
          }
          &.danger {
            background-image: url("../../assets/application/nopass.png");
          }
        }
        .btns {
          width: 93px;
          .el-button {
            width: 93px;
            height: 32px;
            background: #ff5554;
            border-radius: 2px 2px 2px 2px;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            line-height: 32px;
            padding: 0;
            border: 0;
          }
        }
      }
    }
  }
}
</style>
